import _ from 'lodash';
import React, { useEffect } from 'react';
import { Button } from 'src/@vymo/ui/atoms';
import SkeletonLoader from 'src/@vymo/ui/blocks/skelton';
import { Widget } from 'src/@vymo/ui/molecules';
import { Keys, locale } from 'src/i18n';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import EmptyState from '../../components/emptyState';
import ErrorState from '../../components/errorState';
import {
  getKeyMetricsList,
  getKeyMetricsMetadata,
  getStatus,
} from '../../selector';
import { fetchKeyMetricsMetadata } from '../../thunk';
import { fetchLeadKeyMetricsMetadata } from '../../widget/thunk';
import KeyMetricCard from './card';
import styles from './index.module.scss';

function KeyMetricsWidget({
  classNames,
  props,
}: {
  classNames?: string;
  props?: any;
}) {
  const keyMetrics = useAppSelector(getKeyMetricsList);
  const keyMetricsMetadata = useAppSelector(getKeyMetricsMetadata);
  const status = useAppSelector((state) =>
    getStatus(state, 'key_metrics_metadata'),
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (keyMetrics?.length) {
      if (props?.source === 'vo') {
        dispatch(
          fetchLeadKeyMetricsMetadata({ cards: keyMetrics, params: props }),
        );
      } else {
        dispatch(fetchKeyMetricsMetadata({ cards: keyMetrics }));
      }
    }
  }, [dispatch, keyMetrics, props]);

  return (
    <Widget
      title={locale(Keys.KEY_METRICS)}
      content={
        <>
          {status === 'done' && (
            <div className={styles.keyMetricsWrapper}>
              {keyMetricsMetadata?.slice(0, 6)?.map((metric) => (
                <KeyMetricCard metric={metric} />
              ))}
            </div>
          )}
          {Boolean(status === 'done' && keyMetricsMetadata?.length === 0) && (
            <EmptyState />
          )}
          {status === 'error' && <ErrorState />}
          {status === 'loading' && <SkeletonLoader height={300} rect />}
        </>
      }
      classNames={classNames}
      actions={
        <Button
          type="outlined"
          onClick={() => {
            window.location.hash = !_.isEmpty(props)
              ? `/performance/key_metrics?${new URLSearchParams(
                  props,
                ).toString()}`
              : '/performance/key_metrics';
          }}
        >
          {locale(Keys.VIEW_ALL)}
        </Button>
      }
    />
  );
}

export default KeyMetricsWidget;
